import { render, staticRenderFns } from "./SeguimientoC.vue?vue&type=template&id=aeb51db8&lang=pug"
import script from "./SeguimientoC.vue?vue&type=script&lang=js"
export * from "./SeguimientoC.vue?vue&type=script&lang=js"
import style0 from "./SeguimientoC.vue?vue&type=style&index=0&id=aeb51db8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports